import * as React from "react";
import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const footerColumns = [{
  title: "Expertise",
  links: [{
    label: "Netzwerksicherheit",
    href: "/SecuritySolutionsPage"
  }, {
    label: "Infrastrukturberatung",
    href: "/SecuritySolutionsPage"
  }, {
    label: "Cybersecurity-Strategie",
    href: "/SecuritySolutionsPage"
  }]
}, {
  title: "Unternehmen",
  links: [{
    label: "Über SecureNetics",
    href: "/AboutUsPage"
  }, {
    label: "Karriere",
    href: "/CareerPage"
  }, {
    label: "Kontakt",
    href: "/ContactPage"
  }]
}, {
  title: "Rechtliches",
  links: [{
    label: "Impressum",
    href: "/ImprintPage"
  }, {
    label: "Datenschutz & Compliance",
    href: "/ComplianceAndDataProtectionPage"
  }]
}];
export default function Footer() {
  return <section data-section-id="237048" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        {}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 mb-12">
          <Link to="/HomePage" className="inline-block">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/securenetics_logo_dark.png" alt="SecureNetics" className="h-7 w-auto object-contain" />
          </Link>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="LinkedIn">
            <Linkedin className="size-5" />
          </Link>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 mb-16">
          {footerColumns.map((column, i) => <div key={column.title} data-index={i} className="flex flex-col gap-4">
              <h4 className="font-default font-bold text-foreground text-sm tracking-wider uppercase">
                {column.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {column.links.map((link, j) => <li key={link.label} data-index={j}>
                    <Link to={link.href} className="text-sm font-mono text-muted-foreground hover:text-primary transition-colors">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <Separator className="mb-8 bg-border opacity-50" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <p className="font-mono">© {new Date().getFullYear()} SecureNetics. Technologische Exzellenz & Sicherheit.</p>
          <div className="flex items-center gap-2">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
            </span>
            <p className="font-mono tracking-wide uppercase">
              System Status: All Green
            </p>
          </div>
        </div>
      </div>
    </section>;
}